//@ts-strict-ignore
import React, { useContext, useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { compose } from 'recompose';
import * as withContainer from '../../graphql/containers';
import { CustomerContractReference } from '../../graphql/entities';
import mapStateToFormProps from '../../utils/mapStateToFormProps';
import createForm from '../../components/connectedForm/ConnectedForm';
import { default as Form } from '../../components/connectedForm';
import * as input from '../../components/connectedForm/inputComponents';
import { mergeStyles } from '@fluentui/react/lib/Styling';
import { ChoiceGroup, IChoiceGroupOption } from '@fluentui/react';
import ConnectedFormContext from '../../components/Context/ConnectedFormContext';

const optionRootClass = mergeStyles({ display: 'flex', alignItems: 'baseline', width: '100%', position: 'relative' });
const options: IChoiceGroupOption[] = [
  {
    key: 'CUSTOMER',
    text: '',
    ariaLabel: 'Use Customer as special price target',
    onRenderField: (props, render) => {
      return (
        <div className={optionRootClass}>
          {render ? render(props) : null}
          <div style={{ width: '100%', marginLeft: '10px' }}>
            <Form.Field
              dataid="customer"
              component={input.Dropdown}
              label="Customer"
              autoFocus={true}
              readOnly={!props?.checked}
            />
          </div>
        </div>
      );
    },
    styles: {
      choiceFieldWrapper: { width: '100%' },
    },
  },
  {
    key: 'PRICE_SOURCE',
    text: '',
    ariaLabel: 'Use Price Source as special price target',
    onRenderField: (props, render) => {
      return (
        <div className={optionRootClass}>
          {render ? render(props) : null}
          <div style={{ width: '100%', marginLeft: '10px' }}>
            <Form.Field
              dataid="customerPriceSource"
              component={input.Dropdown}
              label="Price Source"
              readOnly={!props?.checked}
            />
          </div>
        </div>
      );
    },
    styles: {
      choiceFieldWrapper: { width: '100%' },
    },
  },
];

const CustomerContractReferenceForm = (props: any) => {
  const [specialPriceTarget, setSpecialPriceTarget] = useState<string | undefined>('CUSTOMER');
  useEffect(() => {
    setSpecialPriceTarget(!props.values.customerPriceSource ? 'CUSTOMER' : 'PRICE_SOURCE');
  }, [Object.keys(props.values).length > 0]);

  const connectedForm = useContext(ConnectedFormContext);
  const dispatch = useDispatch();

  return (
    <Form.FormContainer>
      <Form.Header component={Form.HeaderBlock} />
      <Form.Form>
        <Form.Row>
          <Form.Fieldset cols={1 / 2}>
            <Form.Legend label="General" />
            <ChoiceGroup
              selectedKey={specialPriceTarget}
              options={options}
              label="Choose contract reference target"
              style={{ marginBottom: '15px' }}
              onChange={(event, option) => {
                const value = option?.key;
                setSpecialPriceTarget(value);
                if (value === 'PRICE_SOURCE') {
                  //Clear Customer field when set to Price Source
                  dispatch(connectedForm.change(`customer`, null));
                } else {
                  //Clear Price Source field when set to Customer.
                  dispatch(connectedForm.change(`customerPriceSource`, null));
                }
              }}
            />
            <Form.Field dataid="reference" component={input.BlurTextField} label="Reference" />
            <Form.Field dataid="description" component={input.BlurTextField} label="Description" />
            <Form.Field dataid="agreementDate" component={input.DateField} label="Agreement Date" />
            <Form.Field dataid="commencementDate" component={input.DateField} label="Commencement Date" />
            <Form.Field dataid="expiryDate" component={input.DateField} label="Expiry Date" />
          </Form.Fieldset>
        </Form.Row>
      </Form.Form>
    </Form.FormContainer>
  );
};

export default compose(
  connect(mapStateToFormProps),
  withContainer.formQuery(CustomerContractReference.instance),
  withContainer.defaultRecord(CustomerContractReference.default),
  withContainer.formMutation(CustomerContractReference.update),
  createForm({
    form: CustomerContractReference.type,
    name: CustomerContractReference.formTitle,
    entity: CustomerContractReference,
    queryFragment: CustomerContractReference.fragment,
    defaultReturnUrl: CustomerContractReference.workspaceUrl,
  })
)(CustomerContractReferenceForm);
